const search = !location.search
    ? {} 
    : location.search.substring(1).split('&').map(c => c.split('=')).reduce((a, b) => { a[b[0]] = (b.length > 1 ? b[1] : true); return a; }, {});

const maxInt = Math.pow(2, 32);

export default class Helper {
    static isEmbed() {
        return 'embed' in search;
    }

    static isPrint() {
        return 'print' in search;
    }

    static search() {
        return search;
    }
    
    static normalizeLang(lang) {
        if (lang == 'en') 
            return 'gb';
        return lang;
    }    

    /**
     * Used to bind all methods of given object so that
     * its this always refereneced to that object
     */
    static bind(obj) {
        const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(obj));
        methods
            .filter(method => (method !== 'constructor'))
            .forEach((method) => { obj[method] = obj[method].bind(obj); });
    }

    static newId() {
        let array = [];
        for (let i = 0; i < 24; ++i) {
            let letter = Helper.alphabet[Math.trunc(Math.random() * Helper.alphabet.length)];
            array.push(letter);
        }
        return array.join('');

        //var d = new Date().getTime();
        //var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
        //return 'xxxxxxxxyxxxyxxxxxxxxxxx'.replace(/[xy]/g, c => {
        //    var r = Math.random() * Helper.alphabet.length;
        //    if (d > 0) {
        //        r = (d + r) % Helper.alphabet.length | 0;
        //        d = Math.floor(d / Helper.alphabet.length);
        //    } else {
        //        r = (d2 + r) % Helper.alphabet.length | 0;
        //        d2 = Math.floor(d2 / Helper.alphabet.length);
        //    }
        //    return Helper.alphabet[c === 'x' ? r : (r & 0x3 | 0x8)];
        //});
    }

    static skillIconClass(type) {
        if (type === 'Skill') return 'icon-Crown';
        if (type === 'Expertise') return 'icon-Star';
        if (type === 'Knowledge') return 'icon-Column';
        if (type === 'Graph') return 'icon-Shield';
        if (type === 'Achievemnt') return 'icon-Cup';
        if (type === 'Exercise') return 'icon-Hourglass';
        if (type === 'Vanancy') return 'icon-Tie';
        if (type === 'Course') return 'icon-Headset';
        if (type === 'Lesson') return 'icon-Ringer';
        if (type === 'Material') return 'icon-ClipboardText';
        if (type === 'Subject') return 'icon-Tag';
        return 'icon-WorldWide';
    }

    static levelToIcon(level) {
        if (!level) return "";
        /*
            🍸 Introduction
            📜 Basic
            📚 Advanced
            🥈 Professional
            🥈 ...
            🥈 Expert
            🏆 Cutting Edge
        */
        var levels = ["", "🍸", "🍸", "📚", "🎓", "🏆", "🏆", "💎", "💎", "💎", "🚀",];
        level = Math.max(0, Math.min(levels.length - 1, +level));
        return levels[level];
    }

    static levelToText(level) {
        if (!level) return "";
        var levels = ["", "Introduction", "Introduction", "Basic", "Advanced",
            "Professional", "Professional", "Expert", "Expert", "Expert", "Cutting Edge",];
        level = Math.max(0, Math.min(levels.length - 1, +level));
        return levels[level];
    }

    static levelToDescription(level) {
        let name = this.levelToText(level);
        if (!name) return "";
        if (name == "Introduction") return "You've got main idea of the skill";
        if (name == "Basic") return "You know the basics and can use it";
        if (name == "Advanced") return "You know how to effectively use the skill in most areas";
        if (name == "Professional") return "You can perfectly use this skill";
        if (name == "Expert") return "You are best among best. Professionals come to your for advice";
        if (name == "Cutting Edge") return "It is science. Cutting edge knowledge. It is not skill - it is an Art";
        return "";
    }

    static skillIcon(type) {
        let span = document.createElement('span'); 
        span.classList.add('icon');
        span.classList.add(Helper.skillIconClass(type));
        return span;
    }

    static isMobile() {
        var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
        if (mobile) {
            return true;
        } else {
            return false;
        }
    }    

    static isHorizontal() {
        return window.innerWidth > window.innerHeight;
    }

    static scrollToTop(node) {
        let scroll = Helper.getScrollParent(node);
        node.scrollIntoView();
        scroll.scrollTop -= 60;
    }

    static getScrollParent(node) {
        if (node == null) return null;      
        if (node.scrollHeight > node.clientHeight)
            return node;
        return Helper.getScrollParent(node.parentNode);
    }

    static favicon(url) {
        try {
            let uri = new URL(url);
            return "https://" + uri.hostname + "/favicon.ico";
        } catch (e) {
            return "/static/images/icons/material-favicon.png";
        }
    }

    static addUtm(url, term) {
        try {
            let uri = new URL(url);
            let search = uri.search;
            search = search + (search != "" ? "&" : "?");
            search += "utm_source=infinite.education&utm_medium=cpc&utm_campaign=promotion&utm_term=" + encodeURIComponent(term || "");
            return uri.origin + uri.pathname + search + uri.hash;
        } catch (e) {
            return url;
        }
    }

    static random() {
        if (crypto.getRandomValues) {
            return crypto.getRandomValues(new Uint32Array(1))[0]/maxInt;
        } else {
            return Math.random();
        }
    }

    static shuffle(items) {
        var j, x, i;
        for (i = items.length - 1; i >= 0; i--) {
            //j = Math.floor(Math.random() * (i + 1));
            j = Math.floor(Helper.random() * items.length);
            x = items[i];
            items[i] = items[j];
            items[j] = x;
        }
        return items;
    }

    static tryCanonizeVideoUrl(url) {
        if (!url) return "";
        const result = Helper.canonizeVideoUrl(url);
        return result.ok ? result.url : url;
    }

    static canonizeVideoUrl(url) {
        try {
            let uri = new URL(url);
            let canonicalUrl;
            const path = uri.pathname;
            if (uri.hostname == "youtube.com" || uri.hostname == "www.youtube.com") {
                if (path == "/watch")
                {
                    // e.g. http://www.youtube.com/watch?v=-wtIMTCHWuI
                    const search = uri.search.substr(1).split('&').map(c => c.split('=')).reduce((a, b) => { a[b[0]] = (b.length > 1 ? b[1] : true); return a; }, {});
                    const videoId = search['v'];
                    if (videoId) {
                        canonicalUrl = "https://youtube.com/embed/" + videoId;
                    }
                }
                else if (path.indexOf("/v/-") == 0)
                {
                    // e.g. http://www.youtube.com/v/-wtIMTCHWuI?version=3&autohide=1
                    canonicalUrl = "https://youtube.com/embed/" + path.substring(4);
                }
                else if (path.indexOf("/embed") == 0)
                {
                    // https://www.youtube.com/embed/3kPgd6vYoK8
                    canonicalUrl = url;
                }
            } else if (uri.hostname == "youtu.be") {
                // e.g. http://youtu.be/-wtIMTCHWuI
                canonicalUrl = "https://youtube.com/embed" + path;
            } else if (uri.hostname == "rutube.ru") {
                if (path.indexOf("/video/") == 0) {
                    canonicalUrl = path.substring(7);
                    let index = canonicalUrl.indexOf('/');
                    if (index >= 0) {
                        canonicalUrl = canonicalUrl.substring(0,index);
                    }
                    canonicalUrl = "https://rutube.ru/play/embed/" + canonicalUrl + "/";
                }
            }
        
            return canonicalUrl ? {
                ok: true,
                url: canonicalUrl,
            } : {
                ok: false,
                error: "Provided URL is not supported",
            }
        } catch(e) {
            return {
                ok: false, error: "Malformed url"
            };
        }
    }

    static prepareQuestionAnswers(question) {
        let transform = (text, correct) => { return { text: text, correct: correct, selected: false }; };
        question.allAnswers = [
            ...question.incorrectAnswers.map(text => transform(text, false)),
            ...question.correctAnswers.map(text => transform(text, true))
        ];
        question.multi = question.correctAnswers.length > 1;
        Helper.shuffle(question.allAnswers);
    }

    static unfoldGraph(graph, userStats, data, omitDuplicates) {
        userStats = userStats || {};
        let nodes = graph.nodes;
        let links = graph.links; // links between nodes, excluding top nodes
        let topNodes = graph.topNodes; // links to top nodes
        let materials = data ? data.materials || {} : {};
        let questions = data ? data.questions || {} : {};
        let knowledges = data ? data.knowledges || {} : {};
        let userSkills = data ? data.userSkills || {} : {};

        let graphNodeIndex = nodes.findIndex(c=>c.id == graph.id);
        if (graphNodeIndex >= 0) {
            // graph=>graph Leaf link contains CSS styles + theme etc
            const removed = nodes.splice(graphNodeIndex, 1);            
            graph.data = removed[0].data;
        }
        nodes.push(graph);

        for (let i = 0; i < topNodes.length; ++i) {
            links.push(topNodes[i]);
        }

        let prepare = d => {
            d.parents = [];
            d.materials = [];
            d.questions = [];
            d.knowledges = [];
        };

        let map = {};
        // prepare each node
        for (let i = 0; i < nodes.length; ++i) {
            let node = nodes[i];
            if (node.id in map) {
                console.warn("Duplicate node found", node, map[node.id]);
                continue;
            }
            prepare(node);
            map[node.id] = node;
        }

        // links => parents arrays
        for (let i = 0; i < links.length; ++i) {
            let link = links[i];
            let childId = link.skillId == graph.id ? graph.id : link.skillId; // replace reference to graph into reference on graph
            link.child = map[childId];
            link.parent = map[link.parentId];
            if (link.child && link.parent) {
                if (links[link.parentId] && links[link.parentId][childId]) continue; // duplicate link
                link.child.parents.push(link);
            } else {
                console.warn("Unknown node", link, link.child, link.parent, map);
            }
        }

        // order 
        for (let i = 0; i < nodes.length; ++i) {
            let node = nodes[i];
            node.parents.sort((a, b) => {
                return a.childSortIndex - b.childSortIndex;
            });
        }

        // parents
        for (let i = 0; i < nodes.length; ++i) {
            let node = nodes[i];
            for (let j = 0; j < node.parents.length; ++j) {
                node.parents[j] = node.parents[j].parent;
            }

            // graph Id
            node.rootId = graph.id;

            // userknows & usersKnows
            if (node.usersKnows) {
                for(let i=0;i<node.usersKnows.length;++i) {
                    let item = node.usersKnows[i];
                    node.usersKnows[item.userId] = item;
                    node.userKnows = item;
                }
            }
            if (!node.userKnows) {
                node.userKnows = {knows:false, answered:false};
            }

            // params
            if (node.linkData) {
                try {
                    node.params = JSON.parse(node.linkData);
                } catch (e) {
                    console.warn("failed to parse node params", node.linkData);
                    node.params = {};
                }
            }  else {
                node.params = {};
            }

            if (node.node) {
                node.materials = node.node.materials || [];
                node.materials.forEach(material => {
                    material.favicon = Helper.favicon(material.url);
                });
                node.knowledges = node.node.knowledges || [];

                node.questions = node.node.questions || [];
                node.questions.forEach(question => {
                    Helper.prepareQuestionAnswers(question);
                });
            }
        }        

        //// user statistics
        //if (userStats != null && userStats.length > 0) {
        //    let others = [];
        //    for (let i = 0; i < userStats.length; ++i) {
        //        let subject = userStats[i].value.subject;
        //        if (subject.id in map) continue;
        //        subject.userStats = (+userStats[i].value.count || 0);
        //        others.push(subject);
        //    }
        //    if (others.length > 0) {
        //        let othersRoot = {
        //            id: "othersRoot",
        //            name: "Others",
        //            parents: [],
        //            userStats: 0,
        //            subject: true,
        //        };
        //        graph.parents.push(othersRoot);
        //        for (let i = 0; i < others.length; ++i) {
        //            othersRoot.parents.push(others[i]);
        //            others[i].subject = true;
        //        }
        //    }
        //}

        // calculate graphs stats
        let dfs = callback => {
            let dfsMap = {};
            let dfsImpl = (node, nestLevel) => {
                if (node.id in dfsMap) {
                    console.log("duplicate", node.name);
                    return false;
                }
                dfsMap[node.id] = true;
                let uniqs = [];
                for (let i = 0; i < node.parents.length; ++i) {
                    let ok = dfsImpl(node.parents[i], nestLevel+1);
                    if (ok && omitDuplicates) {
                        uniqs.push(node.parents[i]);
                        node.parents[i].child = node;
                    }
                }
                if (omitDuplicates)
                    node.parents = uniqs;
                node.nestLevel = nestLevel;
                callback(node, node.parents);
                return true;
            }
            dfsImpl(graph, 0);
        }
        dfs(node => {
            node.userStats = node.parents.filter(c => c.subject).map(c => c.userStats).reduce((a, b) => a + b, node.userStats);
            var children = [node.id];
            for (var i in node.parents) {
                children = children.concat(node.parents[i].children);
            }
            //children = children.filter((item) => item != node.id);
            node.children = [...new Set(children)];
            node.deepTotal = node.children.length - 1;
        });
    }

    static dfs(graph, callbacks) {
        let map = {};
        let dfsImpl = node => {
            if (node.id in map) return;
            map[node.id] = true;
            if (callbacks.before)
                callbacks.before(node, node.parents);
            for (let i = 0; i < node.parents.length; ++i) {
                dfsImpl(node.parents[i]);
            }
            if (callbacks.after)
                callbacks.after(node, node.parents);
        }
        dfsImpl(graph);
    }

    static dateToString (value) {
        if (!value) return '';
        let date = new Date(value);
        let today = new Date();
        if (date.toLocaleDateString() == today.toLocaleDateString())
            return date.toLocaleTimeString();
        if (today - date < 86400 * 1000)
            return "Yesterday, " + date.toLocaleTimeString();
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    static getLocal(key) {
        let json = window.localStorage.getItem(key);
        if (!json) return null;
        try {
            return JSON.parse(json);
        } catch(e) {
            return null;
        }
    }

    static setLocal(key, obj) {
        try {
            const json = JSON.stringify(obj);
            window.localStorage.setItem(key, json);
        } catch(e) {
            console.error("Failed to store", key, "to local storage", obj, e);
        }
    }

    static setMetaDescription(text) {
        const meta = document.querySelector('meta[name=description]');
        if (meta) {
            meta.content = text;
        } else {
            console.warn("Missing meta.description tag");
        }
    }

    static setMetaKeywords(text) {
        const meta = document.querySelector('meta[name=keywords]');
        if (meta) {
            meta.content = text;
        } else {
            console.warn("Missing meta.keywords tag");
        }
    }
}   

Helper.alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";